<template>
  <div class="fieldset-country-parts">
    <label for="fieldset-country">
      <span class="label-text">{{ $t('formParts.label.country') }}</span>
      <span class="required" v-if="required">{{ $t('formParts.required') }}</span>
    </label>
    <atom-input-select-object
      class="login-inputs-parts__country-field"
      id="fieldset-country"
      :placeholder="$t('formParts.placeholder.country')"
      v-model="country"
      :error="showError"
      :options="countryData"
      @enter="emitEnter"
      @change="change"
    />

    <form-error-message-parts
      :showError="showError"
      :message="errorMessage !== '' ? errorMessage : $t('formParts.errorMessage.country')"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import Const from '@/util/Const'
import AtomInputSelectObject from '@/components/atoms/input/AtomInputSelectObject.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'
import { Multilingual } from '@/store/stores/collectionModule/documents/GeneralTypes'

type countryType = {
  name: Multilingual
  id: string
}
export type DataType = {
  countryData: Array<countryType>
}

/**
 * フィールドセット お住まいの国入力 バーツ
 */
export default defineComponent({
  name: 'FieldsetCountryParts',
  components: {
    AtomInputSelectObject,
    FormErrorMessageParts,
  },
  props: {
    /**
     * 入力データ
     */
    value: {
      type: String,
      default: '',
    },
    /**
     * 必須フラグ
     */
    required: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーフラグ
     */
    showError: {
      type: Boolean,
      default: false,
    },
    /**
     * エラーメッセージ
     */
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data(): DataType {
    return {
      /**
       * お住まいの国一覧
       */
      countryData: Const.USER_COUNTRY_LIST,
    }
  },
  setup(props, context) {
    /**
     * country
     * @param {string} val 国
     */
    const country = computed({
      get: () => props.value,
      set: (val: string) => context.emit('input', val),
    })
    return {
      country,
    }
  },
  methods: {
    /**
     * 選択が変更されたことを通知する
     */
    change() {
      /**
       * 選択が変更されたことを通知する
       * @event change
       * @type {Object}
       */
      this.$emit('change')
    },
    /**
     * Enter Push
     */
    emitEnter() {
      /**
       * Enterボタン押下を通知する
       * @event enter
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.fieldset-country-parts {
  @include fieldSet();
}
</style>
